/**
 * Module: Scroll Reveal Animations
 * Uses Intersection Observer to add classes when elements enter the viewport.
 */

export const initScrollReveal = () => {
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    
    if (revealElements.length === 0) return;

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15 // Si attiva quando il 15% dell'elemento è visibile
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Aggiunge la classe active
                entry.target.classList.add('is-revealed');
                
                // Se l'elemento ha una classe specifica per un'animazione "one-shot"
                // puoi decidere di smettere di osservarlo qui:
                // observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    revealElements.forEach(el => {
        observer.observe(el);
    });
};
